import React from 'react';
import Power from './Power';
import UsageHome from './UsageHome';
import UsageCabin from './UsageCabin';

import styled from 'styled-components'

const PowerStyled = styled.div`
    margin-top: 40px;
`;

const PowerContainer = props => {
    return (
        <div>
            <PowerStyled><Power /></PowerStyled>
            <PowerStyled><UsageHome /></PowerStyled>
            <PowerStyled><UsageCabin /></PowerStyled>
        </div>
    );
};

export default PowerContainer;
